import {
  formatWarehouseLocation,
  resolveInventoryStockMaterial,
} from '#/modules/imsMgmt/inventoryStock/helper/inventoryStockFilterOptions';

function resolveBaseUnit(row) {
  const baseUnit = row?.baseUnit;
  if (!baseUnit || (!baseUnit.id && !baseUnit.name)) {
    return null;
  }
  return {
    id: baseUnit.id ? String(baseUnit.id) : '',
    name: baseUnit.name ?? '',
  };
}

/**
 * @param {object[]} rows
 * @param {string[]} selectedIds
 * @returns {{
 *   id: string,
 *   stockNo: string,
 *   mtrId: string,
 *   mtrNo: string,
 *   name: string,
 *   warehouseLabel: string,
 *   baseUnit: { id: string, name: string } | null,
 * }[]}
 */
export function buildPrintConfirmItems(rows, selectedIds) {
  const idSet = new Set((selectedIds ?? []).map(String));
  return (rows ?? [])
    .filter((row) => idSet.has(String(row.id)))
    .map((row) => {
      const material = resolveInventoryStockMaterial(row);
      return {
        id: String(row.id),
        stockNo: row.stockNo ?? '—',
        mtrId: material?.id ? String(material.id) : '',
        mtrNo: material?.mtrNo ?? '—',
        name: material?.name ?? '—',
        warehouseLabel: formatWarehouseLocation(row),
        baseUnit: resolveBaseUnit(row),
      };
    });
}

/**
 * 列印順序跟確認清單。沒改離基本單位的庫存不進 unitSelections。
 *
 * @param {object[]} items
 * @param {string[]} selectedIds
 * @param {Record<string, string>} [unitByStockId]
 */
export function buildLabelPrintRequest(items, selectedIds, unitByStockId = {}) {
  const selected = new Set((selectedIds ?? []).map(String));
  const byId = new Map((items ?? []).map((item) => [String(item.id), item]));
  const invStockIds = (items ?? [])
    .map((item) => String(item.id))
    .filter((id) => selected.has(id));
  const unitSelections = invStockIds.flatMap((id) => {
    const chosen = String(unitByStockId?.[id] ?? '').trim();
    const baseId = String(byId.get(id)?.baseUnit?.id ?? '').trim();
    if (!chosen || chosen === baseId) {
      return [];
    }
    return [{ invStockId: id, mtrUnitId: chosen }];
  });

  return { invStockIds, unitSelections };
}
